import React, { Suspense } from 'react';
import { connect } from 'react-redux';

import ErrorBoundary from 'errorBoundry';
import Routes from './routes';
import FallBack from 'layouts/FallBack';
import { getVisibleAlert } from 'features/modal/index.js';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import SessionStorage from 'features/sessionTimeOut/sessionTimeout';
import Loading from 'components/loading';
import './styles.scss?v=1.0.0';
import { LayoutConteact, useLayout } from '../context/appLayout';

function App({ visibleAlert }) { 
	const useLayoutContent = useLayout({});

	return (
		<Suspense fallback={<FallBack />}>
			<LayoutConteact.Provider value={useLayoutContent}>
				<ErrorBoundary>
					<Routes />
					<SessionStorage />
					<Loading />

					{visibleAlert && (
						<SweetAlert {...visibleAlert} style={{ ...(visibleAlert?.style || {}), minWidth: '450px' }}>
							{visibleAlert.content}
						</SweetAlert>
					)}
				</ErrorBoundary>
			</LayoutConteact.Provider>
		</Suspense>
	);
}

App.propTypes = {
	visibleAlert: PropTypes.any
};

const mapStateToProps = state => ({
	visibleAlert: getVisibleAlert(state.modal)
});

export default connect(mapStateToProps, {})(App);
